import React, { FC } from "react";

export interface AnchorProps extends Queries.AnchorDataFragment {}

export const Anchor: FC<AnchorProps> = ({ slug }) => {
  return slug ? <div id={slug} /> : null;
};
